(function () {
  /* Sound files: SOUND_BASE is the folder the demo MP3s are served from (set window.TNF3000_SOUND_BASE on the site). */
  const SOUND_BASE = (window.TNF3000_SOUND_BASE || 'sounds/');
  const KIT = {
    name: 'FRANKENSTEIN BOOM BAP',
    sounds: [
      { name: '808 Kick 1', url: SOUND_BASE + 'tnf3000-a01-808-kick.mp3', s: 'kick', p: { f0: 110, f1: 45, d: .45, click: .5 } }, // A01
      { name: '808 Kick 2', url: SOUND_BASE + 'tnf3000-a02-808-kick.mp3', s: 'kick', p: { f0: 110, f1: 45, d: .45, click: .5 } }, // A02
      { name: '808 Kick 3', url: SOUND_BASE + 'tnf3000-a03-808-kick.mp3', s: 'kick', p: { f0: 110, f1: 45, d: .45, click: .5 } }, // A03
      { name: 'Kick 1', url: SOUND_BASE + 'tnf3000-a04-kick-1.mp3', s: 'kick', p: { f0: 110, f1: 45, d: .45, click: .5 } }, // A04
      { name: 'Kick 2', url: SOUND_BASE + 'tnf3000-a05-kick-2.mp3', s: 'kick', p: { f0: 110, f1: 45, d: .45, click: .5 } }, // A05
      { name: 'Snare 1', url: SOUND_BASE + 'tnf3000-a06-snare1.mp3', s: 'snare', p: { tone: 190, d: .28, noise: .8 } }, // A06
      { name: 'Snare 2', url: SOUND_BASE + 'tnf3000-a07-snare-2.mp3', s: 'snare', p: { tone: 190, d: .28, noise: .8 } }, // A07
      { name: 'Clap 3', url: SOUND_BASE + 'tnf3000-a08-clap-3.mp3', s: 'clap', p: {} }, // A08
      { name: 'Snare 4', url: SOUND_BASE + 'tnf3000-a09-snare-4.mp3', s: 'snare', p: { tone: 190, d: .28, noise: .8 } }, // A09
      { name: 'Snare 5', url: SOUND_BASE + 'tnf3000-a10-snare-5.mp3', s: 'snare', p: { tone: 190, d: .28, noise: .8 } }, // A10
      { name: 'Hat 1', url: SOUND_BASE + 'tnf3000-a11-hat-1.mp3', s: 'hat', p: { d: .06, hp: .75 } }, // A11
      { name: 'Hat 2', url: SOUND_BASE + 'tnf3000-a12-hat-2.mp3', s: 'hat', p: { d: .06, hp: .75 } }, // A12
      { name: 'Hat 3', url: SOUND_BASE + 'tnf3000-a13-hat-3.mp3', s: 'hat', p: { d: .06, hp: .75 } }, // A13
      { name: 'Hat 4', url: SOUND_BASE + 'tnf3000-a14-hat-4.mp3', s: 'hat', p: { d: .06, hp: .75 } }, // A14
      { name: 'Open Hat 1', url: SOUND_BASE + 'tnf3000-a15-open-hi-hat1.mp3', s: 'hat', p: { d: .38, hp: .65 } }, // A15
      { name: 'Boom Warning', url: SOUND_BASE + 'tnf3000-a16-boom-warning.mp3', s: 'shaker', p: {} }, // A16
      { name: 'BB Kick 1', url: SOUND_BASE + 'tnf3000-b01-boom-bap-kick-1.mp3', s: 'kick', p: { f0: 110, f1: 45, d: .45, click: .5 } }, // B01
      { name: 'BB Kick 2', url: SOUND_BASE + 'tnf3000-b02-boom-bap-kick-2.mp3', s: 'kick', p: { f0: 110, f1: 45, d: .45, click: .5 } }, // B02
      { name: 'BB Kick 3', url: SOUND_BASE + 'tnf3000-b03-boom-bap-kick-3.mp3', s: 'kick', p: { f0: 110, f1: 45, d: .45, click: .5 } }, // B03
      { name: 'BB Kick 4', url: SOUND_BASE + 'tnf3000-b04-boom-bap-kick-4.mp3', s: 'kick', p: { f0: 110, f1: 45, d: .45, click: .5 } }, // B04
      { name: 'BB Kick 5', url: SOUND_BASE + 'tnf3000-b05-boom-bap-kick-5.mp3', s: 'kick', p: { f0: 110, f1: 45, d: .45, click: .5 } }, // B05
      { name: 'BB Clap 1', url: SOUND_BASE + 'tnf3000-b06-boom-bap-drums-clap-1.mp3', s: 'clap', p: {} }, // B06
      { name: 'BB Clap 2', url: SOUND_BASE + 'tnf3000-b07-boom-bap-drums-clap-2.mp3', s: 'clap', p: {} }, // B07
      { name: 'BB Snare 3', url: SOUND_BASE + 'tnf3000-b08-boom-bap-snare-3.mp3', s: 'snare', p: { tone: 190, d: .28, noise: .8 } }, // B08
      { name: 'BB Clap 4', url: SOUND_BASE + 'tnf3000-b09-boom-bap-drums-clap-4.mp3', s: 'clap', p: {} }, // B09
      { name: 'BB Clap 5', url: SOUND_BASE + 'tnf3000-b10-boom-bap-drums-clap-5.mp3', s: 'clap', p: {} }, // B10
      { name: 'BB Open Hat 1', url: SOUND_BASE + 'tnf3000-b11-boom-bap-open-hat-1.mp3', s: 'hat', p: { d: .38, hp: .65 } }, // B11
      { name: 'BB Open Hat 2', url: SOUND_BASE + 'tnf3000-b12-boom-bap-open-hat2.mp3', s: 'hat', p: { d: .38, hp: .65 } }, // B12
      { name: 'BB Open Hat 3', url: SOUND_BASE + 'tnf3000-b13-boom-bap-oh-3.mp3', s: 'hat', p: { d: .38, hp: .65 } }, // B13
      { name: 'BB Open Hat 4', url: SOUND_BASE + 'tnf3000-b14-boom-bap-oh-4.mp3', s: 'hat', p: { d: .38, hp: .65 } }, // B14
      { name: 'BB Hat 5', url: SOUND_BASE + 'tnf3000-b15-boom-bap-hat-5.mp3', s: 'hat', p: { d: .06, hp: .75 } }, // B15
      { name: 'Perc Loop Fill', url: SOUND_BASE + 'tnf3000-b16-perc-loop-fill.mp3', s: 'shaker', p: {} }, // B16
    ]
  };
  const KEYS = ['z','x','c','v','a','s','d','f','q','w','e','r','1','2','3','4']; // pad 1..16
  const ORDER = [12,13,14,15, 8,9,10,11, 4,5,6,7, 0,1,2,3];                       // MPC layout: pad 13 top-left

  let ctx = null, master = null, buffers = [], loaded = false;
  let soundsReady = Promise.resolve();
  // On the website the page sets window.TNF3000_ZIP; the ZIP is fetched early so sounds are ready on the first tap.
  const zipPromise = (window.TNF3000_ZIP && window.JSZip)
    ? fetch(window.TNF3000_ZIP).then(r => { if (!r.ok) throw new Error('zip'); return r.arrayBuffer(); }).then(b => window.JSZip.loadAsync(b)).catch(() => null)
    : null;
  let bank = 0, sel = 0, playing = false, recOn = false;
  let tempo = 90, swing = 58, step = 0, nextTime = 0, timer = null;
  const pattern = KIT.sounds.map(() => new Array(16).fill(false));
  // starter beat so Play sounds good straight away
  [0, 7, 10].forEach(i => pattern[3][i] = true);             // A04 Kick 1
  [4, 12].forEach(i => pattern[5][i] = true);                // A06 Snare 1
  [0,2,4,6,8,10,12,14].forEach(i => pattern[10][i] = true);  // A11 Hat 1
  pattern[14][14] = true;                                    // A15 Open Hat 1

  /* ---------------- tiny DSP helpers ---------------- */
  function mk(sec) { return new Float32Array(Math.max(1, Math.floor(ctx.sampleRate * sec))); }
  function rnd() { return Math.random() * 2 - 1; }
  function finish(d, gain, dirt) {
    let peak = 0;
    for (let i = 0; i < d.length; i++) {
      let v = d[i];
      if (dirt) v = Math.tanh(v * (1 + dirt * 6)) * (1 - dirt * .2);
      d[i] = v; peak = Math.max(peak, Math.abs(v));
    }
    const g = (gain || .9) / (peak || 1);
    // light "tape" warmth: one-pole lowpass
    let y = 0; const a = .55;
    for (let i = 0; i < d.length; i++) { y = y + a * (d[i] * g - y); d[i] = y; }
    const fade = Math.min(200, d.length);
    for (let i = 0; i < fade; i++) d[d.length - 1 - i] *= i / fade;
    const b = ctx.createBuffer(1, d.length, ctx.sampleRate); b.copyToChannel(d, 0); return b;
  }
  const R = () => ctx.sampleRate;
  const SYN = {
    kick(p) {
      const d = mk(p.d + .05), sr = R(); let ph = 0;
      for (let i = 0; i < d.length; i++) {
        const t = i / sr, f = p.f1 + (p.f0 - p.f1) * Math.exp(-t * 28);
        ph += 2 * Math.PI * f / sr;
        d[i] = Math.sin(ph) * Math.exp(-t / (p.d * .45)) + (t < .004 ? rnd() * p.click : 0);
      }
      return finish(d, .95, p.dirt || .15);
    },
    snare(p) {
      const d = mk(p.d + .05), sr = R(); let ph = 0, lp = 0;
      for (let i = 0; i < d.length; i++) {
        const t = i / sr; ph += 2 * Math.PI * p.tone / sr;
        const n = rnd(); lp += .35 * (n - lp);
        d[i] = Math.sin(ph) * Math.exp(-t * 30) * .7 + (n - lp) * p.noise * Math.exp(-t / (p.d * .35));
      }
      return finish(d, .9, p.dirt || .1);
    },
    clap() {
      const d = mk(.35), sr = R(); let lp = 0;
      for (let i = 0; i < d.length; i++) {
        const t = i / sr; let env = 0;
        [0, .011, .022, .034].forEach((o, k) => { if (t >= o) env = Math.max(env, Math.exp(-(t - o) * (k < 3 ? 140 : 16))); });
        const n = rnd(); lp += .5 * (n - lp); d[i] = (n - lp) * env;
      }
      return finish(d, .85);
    },
    hat(p) {
      const d = mk(p.d + .02), sr = R(); let x1 = 0, y1 = 0;
      for (let i = 0; i < d.length; i++) {
        const t = i / sr, n = rnd(); const y = p.hp * (y1 + n - x1); x1 = n; y1 = y;
        d[i] = y * Math.exp(-t / (p.d * .4));
      }
      return finish(d, .55);
    },
    shaker() { const d = mk(.12), sr = R(); let x1=0,y1=0; for (let i = 0; i < d.length; i++) { const t = i/sr, n = rnd(); const y = .8*(y1+n-x1); x1=n;y1=y; d[i] = y * Math.sin(Math.PI * Math.min(1, t / .12)); } return finish(d, .45); },
  };


  // per-sound mix settings (driven by the faders)
  const level = KIT.sounds.map(() => 100), tune = KIT.sounds.map(() => 0), decay = KIT.sounds.map(() => 100);

  async function ensureAudio() {
    if (!ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      ctx = new AC();
      master = ctx.createGain(); master.gain.value = masterVol / 100 * 0.9;
      const comp = ctx.createDynamicsCompressor(); comp.threshold.value = -10; comp.ratio.value = 3;
      master.connect(comp).connect(ctx.destination);
    }
    if (ctx.state === 'suspended') { try { await ctx.resume(); } catch (e) {} }
    if (!loaded) {
      loaded = true;
      buffers = KIT.sounds.map(s => SYN[s.s](s.p));
      const decode = (a, i) => new Promise(res => {
        try { ctx.decodeAudioData(a, b => { buffers[i] = b; res(); }, () => res()); } catch (e) { res(); }
      });
      if (zipPromise) {
        // site version: all demo sounds arrive in one ZIP from the store's files
        soundsReady = zipPromise.then(z => Promise.all(KIT.sounds.map((s, i) => {
          const f = z && z.file(s.url.split('/').pop());
          return f ? f.async('arraybuffer').then(a => decode(a, i)) : null;
        }))).catch(() => {});
      } else {
        soundsReady = Promise.all(KIT.sounds.map((s, i) => s.url
          ? fetch(s.url).then(r => r.arrayBuffer()).then(a => decode(a, i)).catch(() => {})
          : null));
      }
    }
    // give the real sounds a moment to arrive before the first beat
    await Promise.race([soundsReady, new Promise(r => setTimeout(r, 2500))]);
  }
  function trigger(i, when) {
    const b = buffers[i]; if (!b) return;
    const t = Math.max(when || 0, ctx.currentTime);
    const src = ctx.createBufferSource(); src.buffer = b;
    src.playbackRate.value = Math.pow(2, tune[i] / 12);
    const g = ctx.createGain(); g.gain.value = level[i] / 100;
    if (decay[i] < 100) {
      const len = b.duration / src.playbackRate.value * Math.max(.05, decay[i] / 100);
      g.gain.setValueAtTime(level[i] / 100, t);
      g.gain.linearRampToValueAtTime(0.0001, t + len);
      src.stop(t + len + .01);
    }
    src.connect(g).connect(master); src.start(t);
  }

  /* ---------------- UI ---------------- */
  const $ = id => document.getElementById(id);
  const padsEl = $('pads'), stepsEl = $('steps'), cellsEl = $('lcdCells');
  let masterVol = 80;
  const padEls = [];
  ORDER.forEach(slot => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'pad';
    b.innerHTML = '<span class="pnum"></span><span class="pkey"></span><span class="pname"></span><span class="pdot"></span>';
    b.addEventListener('pointerdown', e => { e.preventDefault(); hitSlot(slot); });
    b.addEventListener('keydown', e => { if (e.key === 'Enter') hitSlot(slot); });
    padsEl.appendChild(b); padEls[slot] = b;
  });
  for (let i = 0; i < 16; i++) {
    const s = document.createElement('button');
    s.type = 'button'; s.className = 'step'; s.innerHTML = '<span>' + (i + 1) + '</span>';
    s.setAttribute('aria-label', 'Step ' + (i + 1));
    s.addEventListener('click', () => { const idx = soundIndex(sel); if (idx < 0) return; pattern[idx][i] = !pattern[idx][i]; render(); });
    stepsEl.appendChild(s);
    cellsEl.appendChild(document.createElement('i'));
  }
  const stepEls = Array.from(stepsEl.children), cellEls = Array.from(cellsEl.children);

  /* faders: [label, colour, min, max, get, set, format] */
  const FADERS = [
    ['Tempo', 'f-red', 60, 140, () => tempo, v => { tempo = v; }, v => v],
    ['Swing', 'f-orange', 50, 75, () => swing, v => { swing = v; }, v => v + '%'],
    ['Level', 'f-yellow', 0, 100, () => level[curIdx()], v => { level[curIdx()] = v; }, v => v],
    ['Tune', 'f-beige', -12, 12, () => tune[curIdx()], v => { tune[curIdx()] = v; }, v => (v > 0 ? '+' : '') + v],
    ['Decay', 'f-white', 5, 100, () => decay[curIdx()], v => { decay[curIdx()] = v; }, v => v],
    ['Master', 'f-white', 0, 100, () => masterVol, v => { masterVol = v; if (master) master.gain.value = v / 100 * 0.9; }, v => v]
  ];
  const faderEls = FADERS.map((f, n) => {
    const [label, col, min, max, get, set, fmt] = f;
    const wrap = document.createElement('div'); wrap.className = 'fader ' + col;
    const id = 'fader-' + label.toLowerCase();
    wrap.innerHTML = '<span class="val"></span><div class="track" tabindex="0" role="slider" id="' + id + '" aria-label="' + label + '" aria-valuemin="' + min + '" aria-valuemax="' + max + '"><span class="ticks"></span><span class="cap"></span></div><label for="' + id + '">' + label + '</label>';
    const track = wrap.querySelector('.track');
    function fromY(clientY) {
      const r = track.getBoundingClientRect(), pad = 9;
      const p = 1 - Math.min(1, Math.max(0, (clientY - r.top - pad) / (r.height - pad * 2)));
      apply(Math.round(min + p * (max - min)));
    }
    function apply(v) { if (curIdx() < 0 && n >= 2 && n <= 4) return; set(Math.min(max, Math.max(min, v))); render(); }
    track.addEventListener('pointerdown', e => { e.preventDefault(); track.setPointerCapture(e.pointerId); track.focus(); fromY(e.clientY); });
    track.addEventListener('pointermove', e => { if (track.hasPointerCapture(e.pointerId)) fromY(e.clientY); });
    track.addEventListener('keydown', e => {
      const stepSize = (max - min) > 40 ? 2 : 1;
      if (e.key === 'ArrowUp' || e.key === 'ArrowRight') { e.preventDefault(); apply(get() + stepSize); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowLeft') { e.preventDefault(); apply(get() - stepSize); }
    });
    $('faders').appendChild(wrap);
    return { wrap, track, cap: wrap.querySelector('.cap'), val: wrap.querySelector('.val'), min, max, get, fmt };
  });

  /* 16 pads per bank on desktop, 8 on phones */
  const phoneMQ = window.matchMedia('(max-width: 800px)');
  let per = phoneMQ.matches ? 8 : 16;
  const bankBtns = Array.from(document.querySelectorAll('#tnf3k .bank-btn'));
  function nBanks() { return Math.ceil(KIT.sounds.length / per); }
  function bankName(n) { if (per === 16) return 'Bank ' + 'AB'[n]; return 'AB'[Math.floor(n / 2)] + (n % 2 ? ' 9-16' : ' 1-8'); }
  function applyPer() {
    const keep = curIdx(); per = phoneMQ.matches ? 8 : 16;
    const k = keep >= 0 ? keep : 0; bank = Math.floor(k / per); sel = k - bank * per;
    padEls.forEach((el, slot) => el.classList.toggle('off-page', slot >= per));
    render();
  }
  if (phoneMQ.addEventListener) phoneMQ.addEventListener('change', applyPer); else if (phoneMQ.addListener) phoneMQ.addListener(applyPer);
  function soundIndex(slot) { if (slot >= per) return -1; const i = bank * per + slot; return i < KIT.sounds.length ? i : -1; }
  function curIdx() { return soundIndex(sel); }
  function padLabel(slot) { const i = bank * per + slot; return 'AB'[Math.floor(i / 16)] + String(i % 16 + 1).padStart(2, '0'); }

  function render() {
    padEls.forEach((el, slot) => {
      const idx = soundIndex(slot);
      el.classList.toggle('empty', idx < 0);
      el.classList.toggle('selected', slot === sel);
      el.classList.toggle('has-steps', idx >= 0 && pattern[idx].some(Boolean));
      el.querySelector('.pnum').textContent = padLabel(slot);
      el.querySelector('.pkey').textContent = KEYS[slot].toUpperCase();
      el.querySelector('.pname').textContent = idx >= 0 ? KIT.sounds[idx].name : '—';
      el.setAttribute('aria-label', 'Pad ' + padLabel(slot) + (idx >= 0 ? ' ' + KIT.sounds[idx].name : ' empty'));
    });
    const idx = curIdx();
    stepEls.forEach((el, i) => { const on = idx >= 0 && pattern[idx][i]; el.classList.toggle('on', on); el.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    cellEls.forEach((el, i) => el.classList.toggle('on', idx >= 0 && pattern[idx][i]));
    const nm = idx >= 0 ? KIT.sounds[idx].name.toUpperCase() : 'EMPTY';
    $('stepsFor').textContent = padLabel(sel) + ' ' + nm;
    $('lcdPad').textContent = 'PAD ' + padLabel(sel) + ' ' + nm;
    $('lcdTempo').textContent = 'BPM ' + String(tempo).padStart(3, '0') + '  SWING ' + swing + '%';
    $('lcdParams').textContent = idx >= 0 ? 'LVL ' + String(level[idx]).padStart(3, '0') + '  TUNE ' + (tune[idx] > 0 ? '+' : '') + tune[idx] + '  DCY ' + String(decay[idx]).padStart(3, '0') : '';
    $('lcdRec').textContent = recOn ? (playing ? '● REC' : 'REC ARM') : '';
    $('lcdMode').textContent = playing ? '▶ PLAY' : 'MAIN';
    $('bankLabel').textContent = per === 16 ? bankName(bank) : 'Bank ' + bankName(bank);
    bankBtns.forEach((b, n) => { b.style.display = n < nBanks() ? '' : 'none'; b.querySelector('.bl').textContent = bankName(n); b.classList.toggle('on', n === bank); });
    $('btnBank').classList.toggle('on', bank > 0);
    $('btnPlay').classList.toggle('on', playing); $('btnRec').classList.toggle('on', recOn);
    $('btnPlay').lastChild.textContent = playing ? 'Stop' : 'Play';
    faderEls.forEach(f => {
      const v = f.get(); const ok = v !== undefined;
      const p = ok ? (v - f.min) / (f.max - f.min) : 0;
      f.cap.style.top = 'calc(9px + ' + ((1 - p) * 100).toFixed(2) + '% - ' + ((1 - p) * 18).toFixed(2) + 'px)';
      f.val.textContent = ok ? f.fmt(v) : '--';
      f.track.setAttribute('aria-valuenow', ok ? v : f.min);
    });
  }

  async function hitSlot(slot) {
    await ensureAudio();
    const idx = soundIndex(slot); if (idx < 0) return;
    sel = slot; trigger(idx, 0);
    const el = padEls[slot]; el.classList.add('hit'); setTimeout(() => el.classList.remove('hit'), 110);
    if (recOn && playing) {
      const spb = 60 / tempo / 4, ahead = nextTime - ctx.currentTime;
      const s = ahead > spb / 2 ? (step + 15) % 16 : step;
      pattern[idx][s] = true;
    }
    render();
  }

  /* ---------------- sequencer ---------------- */
  function schedule() {
    const spb = 60 / tempo / 4;
    while (nextTime < ctx.currentTime + 0.12) {
      const swingOff = (step % 2 === 1) ? (swing - 50) / 50 * spb : 0;
      const t = nextTime + swingOff;
      pattern.forEach((row, i) => { if (row[step]) trigger(i, t); });
      const shown = step;
      setTimeout(() => showStep(shown), Math.max(0, (t - ctx.currentTime) * 1000));
      nextTime += spb; step = (step + 1) % 16;
    }
  }
  function showStep(s) {
    if (!playing) return;
    stepEls.forEach((el, i) => el.classList.toggle('now', i === s));
    cellEls.forEach((el, i) => el.classList.toggle('now', i === s));
    $('lcdStep').textContent = 'STEP ' + String(s + 1).padStart(2, '0');
    pattern.forEach((row, i) => {
      if (!row[s]) return;
      const slot = i - bank * per;
      if (slot >= 0 && slot < per) { const el = padEls[slot]; el.classList.add('hit'); setTimeout(() => el.classList.remove('hit'), 90); }
    });
  }
  async function togglePlay() {
    await ensureAudio();
    playing = !playing;
    if (playing) { step = 0; nextTime = ctx.currentTime + 0.06; timer = setInterval(schedule, 25); schedule(); }
    else { clearInterval(timer); stepEls.forEach(el => el.classList.remove('now')); cellEls.forEach(el => el.classList.remove('now')); $('lcdStep').textContent = 'STEP --'; }
    render();
  }
  function setBank(b) { bank = b; if (soundIndex(sel) < 0) sel = 0; render(); }

  $('btnPlay').addEventListener('click', togglePlay);
  $('btnPlay2').addEventListener('click', togglePlay);
  $('btnRec').addEventListener('click', () => { recOn = !recOn; render(); });
  $('btnBank').addEventListener('click', () => setBank((bank + 1) % nBanks()));
  $('btnClearPad').addEventListener('click', () => { const i = curIdx(); if (i >= 0) pattern[i].fill(false); render(); });
  $('btnClearAll').addEventListener('click', () => { pattern.forEach(r => r.fill(false)); render(); });
  bankBtns.forEach((b, n) => b.addEventListener('click', () => setBank(n)));

  document.addEventListener('keydown', e => {
    if (e.target && (/input|textarea|select/i.test(e.target.tagName) || e.target.getAttribute('role') === 'slider')) return;
    if (e.metaKey || e.ctrlKey || e.altKey || e.repeat) return;
    if (e.code === 'Space') { e.preventDefault(); togglePlay(); return; }
    const k = KEYS.indexOf(e.key.toLowerCase());
    if (k >= 0 && k < per) { e.preventDefault(); hitSlot(k); }
  });

  applyPer();
})();
